type ConvocationMessageData = {
  courseName: string,
  termLabel: string,
  noticeItem: string,
  noticeUrl: string,
  // 'dd/mm/aaaa HH:mm', como no campo Início e na data final do processo.
  startAt: string,
  processEnd: string,
  // 'dd/mm/aaaa'
  resultPublicationDate: string,
};

export const RESULT_PUBLICATION_SITE = 'https://cmmg.edu.br/cursos/como-ingressar/';

// '08:00' vira '8h' e '23:59' vira '23h59'.
export const formatHour = (time: string): string => {
  const [hour, minute] = time.split(':');

  return `${Number(hour)}h${minute === '00' ? '' : minute}`;
};

const splitDateTime = (value: string) => {
  const [date = '', time = ''] = (value || '').trim().split(' ');

  return { date, hour: time ? formatHour(time) : '' };
};

// Texto padrão da convocação (definido pela Secretaria). Abre preenchido no modal e
// pode ser editado antes do envio; o link individual e a assinatura vêm do convoked.html.
export const buildConvocationMessage = ({
  courseName,
  termLabel,
  noticeItem,
  noticeUrl,
  startAt,
  processEnd,
  resultPublicationDate,
}: ConvocationMessageData): string => {
  const start = splitDateTime(startAt);
  const end = splitDateTime(processEnd);

  return [
    `Você foi classificado no Processo de Transferência Externa para o curso de ${courseName} `
      + `da Faculdade de Ciências Médicas de Minas Gerais, referente ao ${termLabel}.`,
    `Para a próxima etapa, conforme item ${noticeItem} do Edital de Inscrição do Processo Seletivo, `
      + 'o candidato classificado deverá encaminhar a documentação para análise, de acordo com o '
      + `item ${noticeItem} do Edital.`,
    `O Edital de Inscrição está disponível no seguinte link: ${noticeUrl}`,
    `Reforçamos que o prazo para anexar a documentação no sistema, será do dia ${start.date}, `
      + `a partir das ${start.hour}, até às ${end.hour} do dia ${end.date}.`,
    'O não envio da documentação dentro do prazo estabelecido terá caráter eliminatório.',
    `O resultado final será publicado no site ${RESULT_PUBLICATION_SITE}, no dia ${resultPublicationDate}.`,
    'Agradecemos pela atenção e permanecemos à disposição.',
  ].join('\n\n');
};
